import React from "react";
import TopicDefaultIcon from "../../../Images/TopicIcons/topicDefaultIcon.png";

type Props = {
  topicCode: string;
  className?: string;
};

export default class TopicIcon extends React.Component<Props> {
  render() {
    return <img className={this.props.className} src={TopicDefaultIcon} />;
  }
}
